export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-[#D4AF37]/25 bg-[#F4EFE6]/70 py-5"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-xs tracking-[0.4em] text-[#B89759]/80 uppercase">
              {item}
            </span>
            <svg viewBox="0 0 24 24" className="h-3 w-3 text-[#D4AF37]/70" fill="currentColor">
              <path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
